export const DARK_COLOR_SCHEME = 'color-scheme2|color-scheme4|color-scheme7';
export const SMALL_FONT_SIZE = 'small';
export const TARGET_CARD = 'Data From Target';
export const MODEL_CARD = 'Data From AEM';
export const VARIATION_ONE = 'variationone';
export const VARIATION_TWO = 'variationtwo';
export const BRIGHTCOVE_SRC = 'https://players.brightcove.net';
export const FILTER_TYPES = {
  BEDROOMS: 'mi-luxury-spa:bedrooms',
  ANY_BEDROOMS: 'mi-luxury-spa:bedrooms/any',
  COUNTRY: 'mi-luxury-spa:country',
  CONNECTING_ROOMS: 'mi-luxury-spa:connecting-rooms',
  BRANDS: 'mi-luxury-spa:brands',
};
export const MOBILE_COL_LENGTH = 12;
export const COL_LENGTH = 6;
